module.exports = __webpack_public_path__ + "b069184a0ab2dede79935780e7d777b1.woff2";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-bold-webfont.woff2
// module id = 340
// module chunks = 0